import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box, Paper, TextField, Button, Typography, Alert, InputAdornment, IconButton, CircularProgress
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';
import { useSnackbar } from 'notistack';

export default function LoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const { enqueueSnackbar } = useSnackbar();
  const [form, setForm] = useState({ email: '', password: '' });
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await login(form.email, form.password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #1E1B2E 0%, #2D1B4E 50%, #1E1B2E 100%)',
      position: 'relative', overflow: 'hidden'
    }}>
      {/* Background decorations */}
      <Box sx={{
        position: 'absolute', width: 500, height: 500, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(147,51,234,0.15) 0%, transparent 70%)',
        top: -100, right: -100
      }} />
      <Box sx={{
        position: 'absolute', width: 400, height: 400, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(6,182,212,0.1) 0%, transparent 70%)',
        bottom: -100, left: -100
      }} />

      <Paper sx={{
        p: 5, width: '100%', maxWidth: 420, borderRadius: '24px',
        background: 'rgba(255,255,255,0.97)',
        backdropFilter: 'blur(20px)',
        boxShadow: '0 25px 60px rgba(0,0,0,0.3)',
        position: 'relative'
      }}>
        {/* Logo */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
          <Box sx={{ textAlign: 'center' }}>
            <Box sx={{
              mx: 'auto', mb: 2,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              <img
                src="/idn-logo.png"
                alt="IDN Innovación"
                style={{ width: 200, objectFit: 'contain' }}
              />
            </Box>
            <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>Sistema de Gestión de Ventas</Typography>
          </Box>
        </Box>

        <form onSubmit={handleSubmit}>
          {error && <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }}>{error}</Alert>}
          <TextField
            fullWidth label="Correo electrónico" type="email"
            value={form.email} onChange={e => setForm({ ...form, email: e.target.value })}
            sx={{ mb: 2 }} required
          />
          <TextField
            fullWidth label="Contraseña"
            type={showPass ? 'text' : 'password'}
            value={form.password} onChange={e => setForm({ ...form, password: e.target.value })}
            sx={{ mb: 3 }} required
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPass(!showPass)} edge="end">
                    {showPass ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
          <Button fullWidth variant="contained" size="large" type="submit" disabled={loading}
            sx={{ py: 1.5, fontSize: '1rem', borderRadius: '12px' }}
          >
            {loading ? <CircularProgress size={22} color="inherit" /> : 'Iniciar sesión'}
          </Button>
        </form>

        <Typography variant="caption" sx={{ display: 'block', textAlign: 'center', mt: 3, color: 'text.secondary' }}>
          © 2026 IDN Innovación · CRM v1.0
        </Typography>
      </Paper>
    </Box>
  );
}
